angular
  .module('app.ui.form.ctrls')
  .controller('CandidateProfileModalController', [
    '$scope',
    '$uibModalInstance',
    'data',
    '$rootScope',
    'logger',
    function controller($scope, $uibModalInstance, data, $rootScope, logger) {
      // eslint-disable-next-line angular/controller-as
      $scope.candidateId = data

      $rootScope.$on('candidate-deleted', (event, {candidateDeleted}) => {
        if (
          $scope.candidateId === candidateDeleted &&
          !$rootScope.isCandidateDeleted
        ) {
          logger.notify('error', 'Candidate is Deleted by Other Admin')
          $uibModalInstance.dismiss('cancel')
        }
      })
    },
  ])



// WEBPACK FOOTER //
// ./scripts/shared/directives/candidate-profile-modal/candidate-profile-modal.ctrl.js